import { ActivityLogTab } from "@features/mx/shared/components/ActivityLog";
import { InfoCard } from "./InfoCard";
import { QuickActions } from "./QuickActions";
import { Tabs } from "@shared/ui/tabs";
import { Button } from "@shared/ui/button";
import { ArrowLeft } from "lucide-react";
import { FieldConfigurationTab } from "./FieldConfiguration";
import { useParams, useNavigate } from "react-router-dom";
import { useMeterReadingFormatDetail } from "@features/mx/settings/hooks";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";

export const MeterReadFormatDetailLanding = () => {
  const { id } = useParams();
  const remoteUtilityId = getRemoteUtilityId();
  const navigate = useNavigate();
  const { data: meterReadingFormatDetail } = useMeterReadingFormatDetail(
    id,
    remoteUtilityId,
  );
  const tabComponents = {
    fieldConfiguration: {
      label: "Field Configuration",
      shortLabel: "field-configuration",
      component: (
        <FieldConfigurationTab
          meterReadingFormatDetail={meterReadingFormatDetail}
        />
      ),
    },
    logs: {
      label: "Activity Log",
      shortLabel: "logs",
      component: (
        <ActivityLogTab entityId={id} entityType={"meter_reader_format"} />
      ),
    },
  };

  return (
    <div>
      <div className="flex items-center gap-4 mb-2">
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-full hover:bg-gray-100"
          onClick={() => navigate("/mx/settings?tab=read-format&subtab=format")}
        >
          <ArrowLeft className="h-5 w-5 text-gray-700" />
        </Button>
        <div>
          <h1 className="text-xl font-bold text-gray-900">
            {meterReadingFormatDetail?.name}
          </h1>
          <p className="text-sm text-gray-500 font-medium">Meter Read Format</p>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 lg:col-span-9">
          <InfoCard meterReadingFormatDetail={meterReadingFormatDetail} />
        </div>
        <div className="col-span-12 lg:col-span-3">
          <QuickActions meterReadingFormatDetail={meterReadingFormatDetail} />
        </div>
      </div>
      <div className="pt-4">
        <Tabs
          defaultValue="fieldConfiguration"
          tabComponents={tabComponents}
          tabsListFullWidth={true}
          tabsListClassName="grid grid-cols-2"
          disableUrlSync={true}
        />
      </div>
    </div>
  );
};
